import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { useComms } from '../context/CommsContext';
import type { RoomTimelineSnapshot } from '../matrix/timeline';

const emptySnapshot: RoomTimelineSnapshot = {
  messages: [],
  hasMore: false,
  isLoadingOlder: false,
};

const getEmptySnapshot = () => emptySnapshot;
const emptySubscribe = () => () => undefined;
const emptyLoadOlder = () => Promise.resolve();

export const useRoomTimeline = (roomId: string | null) => {
  const { status, getTimelineStore } = useComms();
  const runtimeAvailable =
    status === 'ready' || status === 'reconnecting' || status === 'failed';
  const store = useMemo(
    () => (roomId && runtimeAvailable ? getTimelineStore(roomId) : null),
    [getTimelineStore, roomId, runtimeAvailable],
  );
  useEffect(() => () => store?.dispose(), [store]);
  const snapshot = useSyncExternalStore(
    store?.subscribe ?? emptySubscribe,
    store?.getSnapshot ?? getEmptySnapshot,
    store?.getSnapshot ?? getEmptySnapshot,
  );

  return {
    ...snapshot,
    loadOlder: store?.loadOlder ?? emptyLoadOlder,
  };
};
